import { omit } from '@poseidon/shared-utils';

import { cn } from '../cn';
import { usePlatformLink, type PlatformUrlObject } from '../contexts';
import type { BreadcrumbLinkProps } from './Breadcrumbs';

type QueryValue = NonNullable<Exclude<PlatformUrlObject['query'], string>>[string];

export default function BreadcrumbLink({ children, className, href, ...props }: BreadcrumbLinkProps) {
  const Link = usePlatformLink();

  let processedHref: string | PlatformUrlObject = href;
  if (typeof href === 'object' && href.query && typeof href.query === 'object') {
    const filteredQuery: Record<string, QueryValue> = {};
    for (const [k, v] of Object.entries(href.query)) {
      if (v !== undefined) filteredQuery[k] = v;
    }
    processedHref = { ...href, query: filteredQuery };
  }

  return (
    <Link
      href={processedHref}
      className={cn(
        'flex flex-row items-center gap-2 text-nowrap text-sm hover:underline',
        'text-[#475166] dark:text-white',
        className,
      )}
      {...omit(props, ['backwards'])}>
      {children}
    </Link>
  );
}
